/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskPolicyApprovalDecisionRequestBody,
  RiskPolicyApprovalDecisionRequestBody$Outbound,
  RiskPolicyApprovalDecisionRequestBody$outboundSchema,
} from "../components/riskpolicyapprovaldecisionrequestbody.js";

export type DecideRiskPolicyApprovalSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DecideRiskPolicyApprovalSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DecideRiskPolicyApprovalSecurity = {
  option1?: DecideRiskPolicyApprovalSecurityOption1 | undefined;
  option2?: DecideRiskPolicyApprovalSecurityOption2 | undefined;
};

export type DecideRiskPolicyApprovalRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  riskPolicyApprovalDecisionRequestBody: RiskPolicyApprovalDecisionRequestBody;
};

/** @internal */
export type DecideRiskPolicyApprovalSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DecideRiskPolicyApprovalSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DecideRiskPolicyApprovalSecurityOption1$Outbound,
    DecideRiskPolicyApprovalSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function decideRiskPolicyApprovalSecurityOption1ToJSON(
  decideRiskPolicyApprovalSecurityOption1:
    DecideRiskPolicyApprovalSecurityOption1,
): string {
  return JSON.stringify(
    DecideRiskPolicyApprovalSecurityOption1$outboundSchema.parse(
      decideRiskPolicyApprovalSecurityOption1,
    ),
  );
}

/** @internal */
export type DecideRiskPolicyApprovalSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DecideRiskPolicyApprovalSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DecideRiskPolicyApprovalSecurityOption2$Outbound,
    DecideRiskPolicyApprovalSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function decideRiskPolicyApprovalSecurityOption2ToJSON(
  decideRiskPolicyApprovalSecurityOption2:
    DecideRiskPolicyApprovalSecurityOption2,
): string {
  return JSON.stringify(
    DecideRiskPolicyApprovalSecurityOption2$outboundSchema.parse(
      decideRiskPolicyApprovalSecurityOption2,
    ),
  );
}

/** @internal */
export type DecideRiskPolicyApprovalSecurity$Outbound = {
  Option1?: DecideRiskPolicyApprovalSecurityOption1$Outbound | undefined;
  Option2?: DecideRiskPolicyApprovalSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DecideRiskPolicyApprovalSecurity$outboundSchema: z.ZodMiniType<
  DecideRiskPolicyApprovalSecurity$Outbound,
  DecideRiskPolicyApprovalSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DecideRiskPolicyApprovalSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DecideRiskPolicyApprovalSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function decideRiskPolicyApprovalSecurityToJSON(
  decideRiskPolicyApprovalSecurity: DecideRiskPolicyApprovalSecurity,
): string {
  return JSON.stringify(
    DecideRiskPolicyApprovalSecurity$outboundSchema.parse(
      decideRiskPolicyApprovalSecurity,
    ),
  );
}

/** @internal */
export type DecideRiskPolicyApprovalRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RiskPolicyApprovalDecisionRequestBody:
    RiskPolicyApprovalDecisionRequestBody$Outbound;
};

/** @internal */
export const DecideRiskPolicyApprovalRequest$outboundSchema: z.ZodMiniType<
  DecideRiskPolicyApprovalRequest$Outbound,
  DecideRiskPolicyApprovalRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    riskPolicyApprovalDecisionRequestBody:
      RiskPolicyApprovalDecisionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      riskPolicyApprovalDecisionRequestBody:
        "RiskPolicyApprovalDecisionRequestBody",
    });
  }),
);

export function decideRiskPolicyApprovalRequestToJSON(
  decideRiskPolicyApprovalRequest: DecideRiskPolicyApprovalRequest,
): string {
  return JSON.stringify(
    DecideRiskPolicyApprovalRequest$outboundSchema.parse(
      decideRiskPolicyApprovalRequest,
    ),
  );
}
